import { render } from "./geolanding-markettrends.vue?vue&type=template&id=f9ff41bc"
import script from "./geolanding-markettrends.js?vue&type=script&lang=js"
export * from "./geolanding-markettrends.js?vue&type=script&lang=js"

import "./geolanding-markettrends.vue?vue&type=style&index=0&id=f9ff41bc&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__